import { render, staticRenderFns } from "./subscription-details-card.vue?vue&type=template&id=8955f536&scoped=true&"
import script from "./subscription-details-card.vue?vue&type=script&lang=js&"
export * from "./subscription-details-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8955f536",
  null
  
)

export default component.exports